module.exports = __webpack_public_path__ + "static/media/reports.48ab8699.svg";